import Flickity from './flickity';
import imagesLoaded from 'imagesloaded';

export default class GallerySlider {

	constructor(element) {
		this.element = element;
	}
	
	init() {
		if (this.element instanceof HTMLElement) {
			imagesLoaded(this.element, { background: true }, () => {
				new Flickity(this.element, {
					contain: true,
					cellAlign: 'center',
					pageDots: false,
					wrapAround: true,
				});
			});
		}
	}
}